export enum LocalStorageEnum {
  LANGUAGE = 'lang',
  OPP_TAB = 'opp_tab',
  OPP_ID = 'opp_id_selected'
}
